import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Plus, Layout, Trash2, Star } from "lucide-react";

export default function CmsPages() {
  const [pages, setPages] = useState([]);
  const navigate = useNavigate();
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ title: "", slug: "" });

  const load = async () => {
    const { data } = await api.get("/cms/pages");
    setPages(data);
  };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    const { data } = await api.post("/cms/pages", { ...form, blocks: [], seo: {}, is_home: false, published: true });
    setShowNew(false);
    navigate(`/cms/pages/${data.id}`);
  };

  const remove = async (id) => {
    if (!window.confirm("Seite löschen?")) return;
    await api.delete(`/cms/pages/${id}`);
    load();
  };

  return (
    <div className="p-8 lg:p-12 mv-fade-in">
      <div className="flex items-end justify-between mb-10">
        <div>
          <p className="mv-label mb-2">Seitenbuilder</p>
          <h1 className="font-display text-4xl">Seiten</h1>
        </div>
        <button data-testid="new-page-btn" onClick={() => setShowNew(true)} className="mv-btn">
          <Plus className="w-4 h-4" strokeWidth={1.5} /> Neue Seite
        </button>
      </div>

      {showNew && (
        <form onSubmit={create} className="mv-card p-6 mb-8 mv-fade-in">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="mv-label block mb-1.5">Titel</label>
              <input data-testid="page-title-input" className="mv-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required />
            </div>
            <div>
              <label className="mv-label block mb-1.5">URL-Slug</label>
              <input data-testid="page-slug-input" className="mv-input" value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} required />
            </div>
          </div>
          <div className="flex gap-3 mt-5">
            <button data-testid="page-create-submit" className="mv-btn">Anlegen</button>
            <button type="button" onClick={() => setShowNew(false)} className="mv-btn-ghost">Abbrechen</button>
          </div>
        </form>
      )}

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {pages.map((p) => (
          <Link key={p.id} to={`/cms/pages/${p.id}`} className="mv-card p-6 group" data-testid={`page-card-${p.slug}`}>
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-2 mb-3">
                <Layout className="w-4 h-4" strokeWidth={1.5} style={{ color: "var(--mv-primary)" }} />
                {p.is_home && <Star className="w-3 h-3" strokeWidth={1.5} style={{ color: "var(--mv-accent)" }} fill="currentColor" />}
              </div>
              <button onClick={(e) => { e.preventDefault(); remove(p.id); }} className="p-1 opacity-60 hover:opacity-100">
                <Trash2 className="w-4 h-4" strokeWidth={1.5} />
              </button>
            </div>
            <h3 className="font-display text-xl mb-1">{p.title}</h3>
            <p className="text-xs" style={{ color: "var(--mv-text-muted)" }}>/{p.slug} · {p.blocks?.length || 0} Blöcke</p>
            <p className="text-xs mt-2" style={{ color: p.published ? "var(--mv-secondary)" : "var(--mv-text-muted)" }}>
              {p.published ? "● Veröffentlicht" : "○ Entwurf"}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}
